import { HttpInterceptorFn } from '@angular/common/http';
import { REQUIRES_AUTH } from './auth-context.token';

/**
 * Auth interceptor for BFF session-based authentication.
 * Adds withCredentials: true to requests marked with REQUIRES_AUTH context token.
 * This includes HTTP-only session cookies for BFF authentication.
 *
 * Uses Angular's HttpContext pattern for clean, explicit authentication marking.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Check if this request requires authentication via context token
  const requiresAuth = req.context.get(REQUIRES_AUTH);

  if (requiresAuth) {
    const clonedRequest = req.clone({
      withCredentials: true,
    });
    return next(clonedRequest);
  }

  // Pass through all other requests without credentials
  return next(req);
};
